export default __webpack_public_path__ + "static/media/logo_landing.b4234276.svg";